<script setup>
import { computed } from 'vue';

const props = defineProps({
    role: {
        type: String,
        required: true,
        validator: (value) => ['customer', 'operator', 'ai'].includes(value),
    },
    label: { type: String, default: '' },
    avatarUrl: { type: String, default: '' },
    size: {
        type: String,
        default: 'thread',
        validator: (value) => ['thread', 'timeline'].includes(value),
    },
});

const initials = computed(() => String(props.label || '?')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase());
</script>

<template>
    <span
        class="ticket-desk-avatar"
        :class="[`ticket-desk-avatar--${role}`, `ticket-desk-avatar--${size}`]"
        :aria-label="label || undefined"
    >
        <img v-if="avatarUrl" class="ticket-desk-avatar__img" :src="avatarUrl" alt="">
        <span v-else aria-hidden="true">{{ initials }}</span>
    </span>
</template>
